module.exports = __webpack_public_path__ + "img/oral-hygiene.4531176a.svg";